import { useCallback } from 'react';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { selectedLicenseTypeTransitionsSelector } from '../modules/License/store/selectors';
import { OperationType } from '../modules/License/types/enums';

function useOperationName() {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const selectedLicenseTypeTransitions = useSelector(selectedLicenseTypeTransitionsSelector);

  const getOperationName = useCallback(
    (operation: string) => {
      const { operationName, operationNameInNationalLang } = selectedLicenseTypeTransitions[operation] || {};

      return operation in OperationType
        ? t(operation)
        : language === 'en'
        ? operationName
        : operationNameInNationalLang;
    },
    [language, selectedLicenseTypeTransitions, t]
  );

  return getOperationName;
}

export default useOperationName;
